await loadComponent('./components/mc-element.js', false);

class CollectionSticky extends McElement {

  connectedCallback() {
    this._observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          document.body.classList.add('sticky-collection');
        } else {
          document.body.classList.remove('sticky-collection');
        }
      });
    }, { threshold: 0.1 });
    this._observer.observe(this);
  }
}

if (!customElements.get('collection-sticky')) {
  customElements.define('collection-sticky', CollectionSticky);
}

window.CollectionSticky = CollectionSticky;